const SchoolDress = () => {
    return (
        <div id="dress" className="vision-card overview-card">

            {/* HEADER */}

            <div className="overview-header">

                <h2>
                    SCHOOL DRESS CODE
                </h2>

                <div className="overview-title-line"></div>

            </div>


            {/* SCHOOL NAME */}

            <div className="overview-school-name">
                Nav Jeevan Mission School, Anandnagar
            </div>


            {/* CONTENT */}

            <div className="overview-content">

                <p>
                    The school uniform reflects the discipline, identity and
                    pride of Nav Jeevan Mission School. Students are expected
                    to wear the prescribed uniform neatly, completely and
                    according to the designated days.
                </p>


                {/* BOYS' UNIFORM */}

                <div className="overview-section">

                    <div className="overview-section-heading">

                        <span className="overview-section-dot"></span>

                        <h3>
                            Boys’ Uniform
                        </h3>

                    </div>


                    <div className="dress-table-wrapper">

                        <table className="dress-table">

                            <thead>

                                <tr>
                                    <th>Days</th>
                                    <th>Prescribed Uniform</th>
                                </tr>

                            </thead>

                            <tbody>

                                <tr>
                                    <td>
                                        Monday, Tuesday,
                                        Thursday &amp; Friday
                                    </td>

                                    <td>
                                        White Shirt, Grey Trousers,
                                        School Tie, School Belt
                                        and Black Shoes
                                    </td>
                                </tr>


                                <tr>
                                    <td>
                                        Wednesday
                                    </td>

                                    <td>
                                        White Shirt, White Trousers,
                                        School Tie, School Belt
                                        and White Shoes
                                    </td>
                                </tr>


                                <tr>
                                    <td>
                                        Saturday
                                    </td>

                                    <td>
                                        White Trousers, House T-Shirt,
                                        School Belt
                                        and Sports White Shoe
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* GIRLS' UNIFORM */}

                <div className="overview-section">

                    <div className="overview-section-heading">

                        <span className="overview-section-dot"></span>

                        <h3>
                            Girls’ Uniform
                        </h3>

                    </div>


                    <div className="dress-table-wrapper">

                        <table className="dress-table">

                            <thead>

                                <tr>
                                    <th>Days</th>
                                    <th>Prescribed Uniform</th>
                                </tr>

                            </thead>

                            <tbody>

                                <tr>
                                    <td>
                                        Monday, Tuesday,
                                        Thursday &amp; Friday
                                    </td>

                                    <td>
                                        White Shirt, Grey Skirt/Trousers,
                                        Grey Coat, School Tie,
                                        School Belt and Black Shoes
                                    </td>
                                </tr>


                                <tr>
                                    <td>
                                        Wednesday
                                    </td>

                                    <td>
                                        White Shirt,
                                        White Skirt/Trousers,
                                        Grey Coat, School Belt
                                        and White Shoes
                                    </td>
                                </tr>


                                <tr>
                                    <td>
                                        Saturday
                                    </td>

                                    <td>
                                        House T-Shirt,
                                        White Skirt/Trousers,
                                        Grey Coat, School Belt
                                        and White Shoes
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* UNIFORM & GROOMING GUIDELINES */}

                <div className="overview-section">

                    <div className="overview-section-heading">

                        <span className="overview-section-dot"></span>

                        <h3>
                            Uniform &amp; Grooming Guidelines
                        </h3>

                    </div>


                    <ul className="overview-strengths">

                        <li>
                            Students must wear the complete prescribed uniform
                            on the designated days.
                        </li>

                        <li>
                            Uniforms must be clean, neat and properly ironed.
                        </li>

                        <li>
                            Students must wear the prescribed school belt,
                            tie and shoes.
                        </li>

                        <li>
                            School ID cards must be worn every day.
                        </li>

                        <li>
                            Students are expected to maintain proper hair style,
                            personal hygiene and grooming.
                        </li>

                        <li>
                            The House T-Shirt should be worn only on the
                            designated Saturday.
                        </li>

                        <li>
                            Parents are requested to ensure that students
                            attend school in the complete and correct uniform.
                        </li>

                    </ul>

                </div>


                {/* QUOTE */}

                <div className="overview-highlight">

                    <span>
                        SCHOOL UNIFORM
                    </span>

                    <h3>
                        “A smart uniform reflects discipline, unity and pride in our school.”
                    </h3>

                </div>


                {/* CLOSING */}

                <div className="overview-highlight">

                    <span>
                        NAV JEEVAN MISSION SCHOOL, ANANDNAGAR
                    </span>

                    <h3>
                        Discipline • Unity • Dignity • Excellence
                    </h3>

                </div>

            </div>

        </div>
    );
};

export default SchoolDress;